import React, { useState } from "react";
import { Link } from "react-router-dom";
import Row from "../components/Row";
import Column from "../components/Column";
import TitleUnderlined from "../components/TitleUnderlined";
import Button from "../components/Button";
import Breadcrumb from "../components/Breadcrumb";
import APIInterface from "../tools/APIInterface";
import { RoutesWeb } from "../tools/RoutesWeb";
require('../style/views/loginView.scss');

const ResendTicketsView = () => {
    const [email, setEmail] = useState('');
    const [wasValidated, setWasValidated] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [status, setStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (e.target.checkValidity() === false) {
            setWasValidated('was-validated');
            return;
        }

        if (isLoading) {
            return;
        }

        setIsLoading(true);
        setStatus(null);
        setErrorMessage('');

        APIInterface.resendTickets(email.trim())
            .then((response) => {
                if (response.data?.success) {
                    setStatus('success');
                } else {
                    setStatus('error');
                    setErrorMessage(response.data?.message || 'Ese correo no fue encontrado.');
                }
            })
            .catch((error) => {
                setStatus('error');
                const data = error.response?.data;
                const apiMessage = data?.message
                    || data?.errors?.email?.[0]
                    || (error.response?.status === 429
                        ? 'Demasiados intentos. Espera un momento e inténtalo de nuevo.'
                        : 'Ese correo no fue encontrado.');
                setErrorMessage(apiMessage);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <div className="pt-5 pb-5" id="resendTicketsView">
            <br />
            <br />
            <Breadcrumb items={[
                { title: 'Inicio', route: RoutesWeb.HOME },
                { title: 'Recuperar boletos', active: true },
            ]} />
            <Row>
                <Column className="col-md-6">
                    <TitleUnderlined>¿Extraviaste tus <span className="embercom_overlined">boletos?</span></TitleUnderlined>
                    <br />
                    <br />
                    {status === 'success' ? (
                        <>
                            <div className="alert alert-success" role="alert">
                                Te hemos reenviado los boletos a tu correo electrónico. Revisa tu bandeja de entrada y spam.
                            </div>
                            <Link className="btn btn-main" to={RoutesWeb.HOME}>
                                Volver al inicio
                            </Link>
                        </>
                    ) : (
                        <>
                            <p>
                                Ingresa el correo electrónico que usaste al realizar tu compra con PayPal.
                                Si existe una orden pagada asociada, te reenviaremos tus boletos.
                            </p>
                            <form onSubmit={handleSubmit} className={`needs-validation ${wasValidated}`} noValidate>
                                <div className="form-group">
                                    <label htmlFor="email">Correo electrónico</label>
                                    <input
                                        type="email"
                                        required
                                        id="email"
                                        name="email"
                                        className="form-control"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        disabled={isLoading}
                                    />
                                </div>
                                {status === 'error' && (
                                    <div className="alert alert-danger mt-3" role="alert">
                                        {errorMessage}
                                    </div>
                                )}
                                <br />
                                <Button disabled={isLoading}>
                                    Reenviar boletos
                                    {isLoading ? (
                                        <div
                                            className="spinner-border"
                                            role="status"
                                            style={{
                                                height: '15px',
                                                width: '15px',
                                                fontSize: '10px',
                                                marginLeft: '10px',
                                            }}
                                        />
                                    ) : (
                                        <img
                                            src={require('../assets/arrow_next.png')}
                                            alt="arrowNext"
                                            style={{ marginLeft: '2rem' }}
                                        />
                                    )}
                                </Button>
                            </form>
                        </>
                    )}
                </Column>
                <Column className="col-md-6 d-flex justify-content-center align-items-start">
                    <img src={require('../assets/img3min.png')} alt="Img" style={{ width: '100%', maxWidth: '430px' }} />
                </Column>
            </Row>
            <br />
            <br />
            <br />
            <br />
        </div>
    );
};

export default ResendTicketsView;
